import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";

const StatusBadge = ({ isActive }) => (
  <span
    className={`badge badge-sm ${
      isActive ? "text-bg-success-soft" : "text-bg-danger-soft"
    }`}
  >
    {isActive ? "Active" : "Inactive"}
  </span>
);

const UserOverviewTab = ({ user }) => {
  const isAuditor = user.role === "AUDITOR";

  return (
    <Card className="p-3">
      <Row>
        <Col md={3} className="mb-0">
          <strong>Full Name</strong>
          <div>{user.fullname}</div>
        </Col>
        <Col md={3} className="mb-0">
          <strong>Email</strong>
          <div>{user.email}</div>
        </Col>
        <Col md={3} className="mb-0">
          <strong>Mobile</strong>
          <div>{user.mobile_number || "N/A"}</div>
        </Col>
        {!isAuditor && (
          <>
            <Col md={3} className="mb-0">
              <strong>Location</strong>
              <div>{user.location || "N/A"}</div>
            </Col>
            <Col md={3} className="mb-0">
              <strong>Department</strong>
              <div>{user.department || "N/A"}</div>
            </Col>
            <Col md={3} className="mb-0">
              <strong>Designation</strong>
              <div>{user.designation || "N/A"}</div>
            </Col>
            <Col md={3} className="mb-0">
              <strong>Area(s)</strong>
              <div className="d-flex flex-wrap gap-1 mt-1">
                {user.area && user.area.length > 0 ? (
                  user.area.map((areaName, idx) => (
                    <Badge key={idx} bg="secondary">
                      {areaName}
                    </Badge>
                  ))
                ) : (
                  <span>N/A</span>
                )}
              </div>
            </Col>
          </>
        )}
        <Col md={3} className="mb-0">
          <strong>Status</strong>
          <div className="mt-1">
            <StatusBadge isActive={user.is_active} />
          </div>
        </Col>
        <Col md={3} className="mb-0">
          <strong>Last Login</strong>
          <div>{user.last_login || "Never logged in"}</div>
        </Col>
      </Row>
    </Card>
  );
};

export default UserOverviewTab;
